import React from 'react';
import { styled, StyledProps } from '@glitz/react';
import * as style from '../Style';

const iconStyled = styled({
  display: 'inline-flex',
  width: '1em',
  height: '1em',
  fontSize: style.pixelsToUnit(style.baseLineHeight, style.Unit.Em),
  verticalAlign: 'text-top',
});

export default function factory(Glyph: SVGComponent) {
  return iconStyled(({ compose, ...restProps }: StyledProps & React.HTMLAttributes<HTMLSpanElement>) => (
    <styled.Span {...restProps} css={compose()}>
      <Glyph width="100%" height="100%" fill="currentColor" />
    </styled.Span>
  ));
}
